import Swiper from 'swiper'
import {Navigation, Controller} from 'swiper/modules'

import Site from 'stores/Site'

import Page from 'classes/Page'

export default class About extends Page {
    constructor() {
        super()
    }

    init() {
        super.init()

        this.initStory()
    }

    initStory() {
        const section = Site.page.querySelector('.s-story')
        const textEl = section.querySelector('.text-slider .swiper')
        const yearEl = section.querySelector('.year-slider .swiper')
        const yearPrev = section.querySelector('.year-slider-wrapper .swiper-button-prev')
        const yearNext = section.querySelector('.year-slider-wrapper .swiper-button-next')
        const yearBgs = section.querySelectorAll('.year-slider .year-bg')

        const sharedArgs = {
            speed: 400,
            centeredSlides: true,
            init: false,
        }

        const textSlider = new Swiper(textEl, {
            modules: [Controller],
            ...sharedArgs
        })

        const yearSlider = new Swiper(yearEl, {
            modules: [Controller, Navigation],
            slidesPerView: Site.isMobile ? 1 : 9,
            navigation: {
                nextEl: yearNext,
                prevEl: yearPrev,
            },
            ...sharedArgs
        })

        function addClasses(swiper) {
            swiper.slides.forEach(slide => {
                slide.classList.remove('swiper-slide-before', 'swiper-slide-after')

                for (let i = 1; i <=3; i++) {
                    slide.classList.remove('swiper-slide-before-'+i, 'swiper-slide-after-'+i)
                }
            })

            let activeIndex = swiper.activeIndex

            const beforeCount = 3;
            for (let i = activeIndex - 2, j = beforeCount; i >= 0 && j > 0; i--, j--) {
                const slide = swiper.slides[i]
                slide.classList.add('swiper-slide-before')
                slide.classList.add('swiper-slide-before-' + j)
            }

            const afterCount = 3;
            for (let i = activeIndex + 2, j = 1; i < swiper.slides.length && j <= afterCount; i++, j++) {
                const slide = swiper.slides[i]
                slide.classList.add('swiper-slide-after')
                slide.classList.add('swiper-slide-after-' + j)
            }
        }

        yearSlider.on('init', () => addClasses(yearSlider))
        yearSlider.on('slideChange', () => addClasses(yearSlider))

        textSlider.init()
        yearSlider.init()

        textSlider.controller.control = yearSlider
        yearSlider.controller.control = textSlider

        yearBgs.forEach((el, i) => {
            el.addEventListener('click', () => {
                if (i !== yearSlider.activeIndex) {
                    yearSlider.slideTo(i)
                }
            })
        })
    }

    onResize() {
        super.onResize()
    }

    onScroll() {
        super.onScroll()
    }
}